(($) => {
  $(() => {
    const $localizationForm = $('#localization_form');

    if ($localizationForm.length) {
      const $languageCodeInput = $localizationForm.find('input[name="language_code"]');

      $('#utility-menu, #mobile-menu, #age-gate-modal').on('click', 'a[lang]', (e) => {
        const $a = $(e.currentTarget);
        const languageCode = $a.data('value');

        $languageCodeInput.val(languageCode);

        $localizationForm.trigger('submit');
      });
    }
  });
})(jQuery);
